<form #newCatalogItemForm="ngForm">
  <p-dialog [(visible)]="showDialog" [contentStyle]="{'overflow':'visible'}" [responsive]="true" [resizable]="false"
            [style]="DialogStyle40" [modal]="true" (onHide)="hideDialog()" [closable]="false">

    <p-header>Add Catalog Item</p-header>
    <div style="margin: 10px 0px">

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label style="margin-top:0;">Catalog*</label>
        </div>
        <div class="p-col-2 p-md-2 p-lg-2" style="padding-top:17px!important;">
          <button pButton type="button" class="icon-action" icon="fa fa-th-list" (click)="displayCatalogSelectionDialog = true"></button>
        </div>
        <div class="p-col-7 p-md-6 p-lg-6">
          <strong>{{ selectedCatalog?.label }}</strong>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label for="subtype">Item Type*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown id="subtype" name="subtype" [placeholder]="Validation.DropdownPlaceholder" [(ngModel)]="abstractItem.subtype" [options]="itemTypeDropdown"
                      [filter]="true" filterBy="label,value.name" required (onChange)="onChangeItemType(abstractItem.subtype)"></p-dropdown>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label for="nameOrNumber">Name or Number*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText type="text" id="nameOrNumber" name="nameOrNumber" [maxLength]="Validation.NameOrNumberMaxLength" [(ngModel)]="abstractItem.nameOrNumber"
                 required/>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label for="purchaseTxnDescription">Description*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <textarea pInputTextarea id="purchaseTxnDescription" name="purchaseTxnDescription" [maxLength]="Validation.DescriptionMaxLength" rows="2"
                    [(ngModel)]="abstractItem.purchaseTxnDescription" required></textarea>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>U/M*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown id="unitOfMeasure" name="unitOfMeasure" [placeholder]="Validation.DropdownPlaceholder" required [(ngModel)]="abstractItem.unitOfMeasureId" [options]="uOfMDropdown"
                      [filter]="true"></p-dropdown>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label for="unitCost">Unit Price*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">$</span>
            <input pInputText type="number" name="unitCost" id="unitCost" [min]="0" [(ngModel)]="abstractItem.unitCost" required [style]="{'max-width':'185px'}">
          </div>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Commodity Code</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">

          <p-autoComplete name="commodity" class="autoComplete" field="name" [placeholder]="Validation.AutoCompletePlaceholder"
                          [suggestions]="searchCommodityResults" [minLength]="Validation.AutoCompleteMinLength" [showEmptyMessage]="true"
                          (completeMethod)="searchCommodity($event)"
                          [(ngModel)]="selectedCommodity" (onSelect)="onSelectCommodity()"></p-autoComplete>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Code Type*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown [(ngModel)]="abstractItem.codeType" [placeholder]="Validation.DropdownPlaceholder" name="codeType" [options]="codeTypeDropDown"
                      required>
          </p-dropdown>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Funding Type* </label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{abstractItem.fundingType}}
          <br>
        </div>
      </div>

      <div class="p-grid" *ngIf="ChargeCodeType.isIndirect(abstractItem.codeType)">
        <div class="p-col-3 p-md-3 p-lg-3">
          <label>Operational Expense Account*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown id="opExpAccount" name="opExpAccount" [placeholder]="Validation.DropdownPlaceholder" [filter]="true" [(ngModel)]="abstractItem.operationalExpenseAccountId"
                      [options]="operationalExpenseAccountDropdown" required></p-dropdown>
        </div>
      </div>

      <div class="ui-grid-row" *ngIf="ChargeCodeType.Unallowable == abstractItem.codeType">
        <div class="p-col-3 p-md-3 p-lg-3">
          <label>Unallowable Expense Account*</label>
        </div>
        <div class="p-col-4 p-md-4 p-lg-4">
          <p-dropdown id="unAllowExpenseAcc" name="unAllowExpenseAcc" [placeholder]="Validation.DropdownPlaceholder" [filter]="true" [style]="{'width':'250px'}"
                      [(ngModel)]="abstractItem.operationalExpenseAccountId"
                      [options]="unallowableAccountDropdown" required></p-dropdown>
        </div>
      </div>

      <div class="p-grid" *ngIf="abstractItem.codeType!=ChargeCodeType.DirectProject && ((abstractItem.subtype==ItemType.Inventory) ||(abstractItem.subtype==ItemType.FixedAsset) ||
                                              (abstractItem.subtype==ItemType.BillOfMaterials))">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Asset Account*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown id="assetAccount" name="assetAccount" [placeholder]="Validation.DropdownPlaceholder" [filter]="true" [(ngModel)]="abstractItem.assetAccountId"
                      [options]="assetAccountDropdown" required></p-dropdown>
        </div>
      </div>
    </div>
    <p-footer>
      <div style="margin-top:0px;text-align:right;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" (click)="hideDialog()" label="Close"></button>
        <button pButton type="button" class="button-action" label="Add to Catalog" icon="fa fa-check" (click)="onSubmitAddCatalogItem(abstractItem)"
                [disabled]="!newCatalogItemForm.form.valid||!abstractItem.catalogId"></button>
      </div>
    </p-footer>
  </p-dialog>
  <p-dialog [(visible)]="displayCatalogSelectionDialog" [modal]="true" [responsive]="true">
    <p-tree [value]="catalogTree" styleClass="catalog-selection-overlay" selectionMode="single"
            (onNodeSelect)="onSelectCatalogNode($event)">
    </p-tree>
  </p-dialog>
</form>
